import React from 'react';
import {connect} from 'react-redux';
import {submit, startSubmit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';

import {MODALS, fetchUsers} from 'ducks/users';

import {CreateUserForm} from './components';

class CreateUserModal extends React.Component<any> {
  submitForm = () => {
    this.props.submit('createUser');
  };

  getExtraActions = () => {
    const {closeModalExtraActions} = this.props;

    return [...closeModalExtraActions, () => fetchUsers()];
  };

  render() {
    const {form: {submitting}} = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.EXTRA_SMALL}
        className="CreateUserModal">
        <Modal.Header heading="Create User" />
        <Modal.Body>
          <CreateUserForm getExtraActions={this.getExtraActions} />
        </Modal.Body>

        <Modal.Footer>
          <Modal.SubmitButtons
            submitting={submitting}
            triggerSubmit={this.submitForm}
            closeModal={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  form: {
    submitting: isSubmitting('createUser')(state)
  }
});

const mapDispatchToProps = {startSubmit, submit};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.CREATE_USER)(CreateUserModal)
);
